// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase} from 'firebase/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDaFbN6kUBp-kAGc4JFuyyFwWIl1EOSshc",
  authDomain: "fertiscience-fsr.firebaseapp.com",
  databaseURL: "https://fertiscience-fsr-default-rtdb.firebaseio.com",
  projectId: "fertiscience-fsr",
  storageBucket: "fertiscience-fsr.appspot.com",
  messagingSenderId: "942157939964",
  appId: "1:942157939964:web:7842fbd2270e21136a0379",
  measurementId: "G-XBQ17RYKTQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export const fireStore = getFirestore(app);
export const database = getDatabase(app);

export const db = getFirestore(app)


